import yup from 'src/libs/yup';

const VoucherStampFilterSchema = yup.object().shape({
  label: yup.string().label('Nome'),
  cnpj: yup.string().label('CNPJ'),
  status: yup.string().nullable().label('Status'),
});

export default VoucherStampFilterSchema;
